var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.visible
    ? _c(
        "AppDialog",
        {
          attrs: {
            title: "Skill授权",
            width: "900px",
            height: "520px",
            "btn-footer": false,
          },
          model: {
            value: _vm.config.visible,
            callback: function ($$v) {
              _vm.$set(_vm.config, "visible", $$v)
            },
            expression: "config.visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "div",
                { staticClass: "toolbar" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.onAdd },
                    },
                    [_vm._v("添加授权码")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, border: "", size: "small" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "授权码", "min-width": "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "auth-code-cell" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "auth-code-text" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.maskAuthCode(row.authCode))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "复制授权码",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-document-copy copy-icon",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onCopy(row)
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2962381279
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "名称",
                      "min-width": "140",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "有效期", "min-width": "260" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatValidRange(row))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2787849761
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "description",
                      label: "备注",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "danger-text",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelete(row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1956202088
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrap" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.query.pageIndex,
                      "page-size": _vm.query.pageSize,
                      total: _vm.total,
                      "page-sizes": [10, 20, 50],
                      layout: "total, sizes, prev, pager, next",
                      background: "",
                      small: "",
                    },
                    on: {
                      "size-change": _vm.onSizeChange,
                      "current-change": _vm.onPageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.addConfig.visible
            ? _c(
                "AppDialog",
                {
                  attrs: {
                    title: "添加授权码",
                    width: "480px",
                    height: "auto",
                    loading: _vm.addLoading,
                  },
                  on: { success: _vm.onAddConfirm, close: _vm.onAddClose },
                  model: {
                    value: _vm.addConfig.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.addConfig, "visible", $$v)
                    },
                    expression: "addConfig.visible",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-form-wrap" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "addForm",
                          attrs: {
                            model: _vm.addForm,
                            rules: _vm.addRules,
                            "label-width": "90px",
                            size: "small",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "名称", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入名称",
                                  maxlength: "30",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.addForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "name", $$v)
                                  },
                                  expression: "addForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "有效期", prop: "validRange" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  "start-placeholder": "生效时间",
                                  "end-placeholder": "失效时间（可空表示永久）",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.addForm.validRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "validRange", $$v)
                                  },
                                  expression: "addForm.validRange",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "description" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入备注",
                                  maxlength: "100",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.addForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "description", $$v)
                                  },
                                  expression: "addForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }